import { $seriesState } from '@/widgets/analytics/model';
import { useStore } from 'effector-react';
import { useMemo } from 'react';
interface DataObject {
  name: string;
  data: number[];
}
interface ChartDataHookProps {
  objectsArray?: DataObject[];
  numbersArray?: number[];
}

export const useChartData = ({
  objectsArray,
  numbersArray,
}: ChartDataHookProps): ApexAxisChartSeries => {
  const seriesState = useStore($seriesState);

  const series = useMemo(() => {
    // Проверяем входные данные
    if (!Array.isArray(objectsArray) || !Array.isArray(numbersArray)) {
      throw new Error('Входные параметры должны быть массивами');
    }

    // Создаем результирующий массив
    const result: ApexAxisChartSeries = [];

    objectsArray.forEach((object, objectIndex) => {
      const newData: Array<{ x: number; y: number }> = [];

      numbersArray.forEach((number, numberIndex) => {
        newData.push({
          x: numberIndex + 1,
          y: object.data[numberIndex],
        });
      });

      result.push({
        name: object.name,
        data: newData,
        hidden:
          seriesState.series.find((s) => s.name === object.name)?.disabled ?? false,
      });
    });

    return result;
  }, [objectsArray, numbersArray]);

  return series;
};
